import React from 'react';
import axios from 'axios';
import Head from 'next/head';
import {
    NSPageCategory, NSContext, last, componentLoader, jwtManager, getLangPrefix
} from 'aqlrc';
import ReactPaginate from 'react-paginate';
import Filters from '../components/Filters';
import Layout from '../components/Layout';
import getAPIUrl from '../lib/getAPIUrl';
import { withI18next } from '../lib/withI18n';
import ProductCard from '../components/ProductCard';
import { Router } from '../routes';
import Error from './_error';

const defaultItemPerPage = 15;

class PageCategory extends NSPageCategory {
    static getInitialProps = async function (ctx) {
        const { lang } = ctx.nsGlobals;
        const slugs = ctx.query._slug.split('/');
        let page = 1;
        let slug = '';

        // Gestion des page dans l URL et du slug
        if (last(slugs) * 1 == last(slugs)) {
            page = last(slugs);
            slug = slugs[slugs.length - 2];
            slugs.pop();
        } else {
            page = 1;
            slug = last(slugs);
        }
        let baseUrl = '';
        if (ctx.req) {
            baseUrl = `${ctx.req.protocol}://${ctx.req.headers.host}${ctx.query.lang ? `/${ctx.query.lang}` : ''}/c/${slugs.join('/')}`;
        } else {
            baseUrl = `${window.location.origin}${ctx.query.lang ? `/${ctx.query.lang}` : ''}/c/${slugs.join('/')}`;
        }
        try {
            const taxDisplay = jwtManager.getTaxDisplay(ctx); // HT ou TTC

            const promises = [];
            const categories = [];
            for (let i = 0; i < slugs.length; i++) {
                promises.push(axios.post(`${getAPIUrl(ctx)}v2/category`, {
                    lang,
                    PostBody : {
                        filter    : { [`translation.${lang}.slug`]: slugs[i] },
                        structure : {
                            displayOrder    : 1,
                            filters         : 1,
                            colorName       : 1,
                            metaDescription : 1,
                            productsList    : 1
                        },
                    },
                    withFilter : true,
                }));
            }
            const res = await axios.all(promises);
            for (let i = 0; i < res.length; i++) {
                categories.push(res[i].data);
            }

            const category = categories[categories.length - 1];
            if (!category) {
                return { notFound: true };
            }

            // Chargement des données des composants des 3 champs supplémentaires
            let datasComponentsCategory = {
                nsCms_extraText  : { content: category.extraText },
                nsCms_extraText2 : { content: category.extraText2 },
                nsCms_extraText3 : { content: category.extraText3 }
            };
            datasComponentsCategory = await componentLoader({ content: category.extraText }, datasComponentsCategory, getAPIUrl(ctx), ctx.query.lang || lang);
            datasComponentsCategory = await componentLoader({ content: category.extraText2 }, datasComponentsCategory, getAPIUrl(ctx), ctx.query.lang || lang);
            datasComponentsCategory = await componentLoader({ content: category.extraText3 }, datasComponentsCategory, getAPIUrl(ctx), ctx.query.lang || lang);

            let productsList = {
                data : {
                    datas : [], priceMin : { et: 0, ati: 0 }, priceMax : { et: 0, ati: 0 }, count : 0,
                },
            };

            let globalMin = 0;
            let min = 0;
            let globalMax = 0;
            let max = 0;
            let specialMin = 0;
            let specialMax = 0;
            let filters = {};
            let search = '';
            if (category) {
                if (typeof window !== 'undefined') {
                    if (window.localStorage.getItem('filters') && JSON.parse(window.localStorage.getItem('filters')).category !== category.name) {
                        window.localStorage.removeItem('filters');
                    }
                    if (window.localStorage.getItem('page') && JSON.parse(window.localStorage.getItem('page')).location !== category.name) {
                        window.localStorage.removeItem('page');
                    }
                }
                productsList = await axios.post(`${getAPIUrl(ctx)}v2/products/category/${category._id}`, {
                    lang,
                    withStocks : true,
                    PostBody   : {
                        filter    : typeof window !== 'undefined' && window.localStorage.getItem('filters') && category.name === JSON.parse(window.localStorage.getItem('filters')).category ? JSON.parse(window.localStorage.getItem('filters')).filters : {},
                        structure : {
                            slug            : 1,
                            visible         : 1,
                            pos             : 1,
                            stock           : 1,
                            reviews         : 1,
                            universe        : 1,
                            price           : 1,
                            type            : 1,
                            translation     : 1,
                            images          : 1,
                            pictos          : 1,
                            bundle_sections : 1
                        },
                        populate : ['bundle_sections.products.id'],
                        limit    : defaultItemPerPage,
                        page     : typeof window !== 'undefined' && window.localStorage.getItem('page') && category.name === JSON.parse(window.localStorage.getItem('page')).location ? JSON.parse(window.localStorage.getItem('page')).page : page,
                        sort     : { sortWeight: -1 },
                    },
                });

                // TODO TF1: tentative de correction du filtre dans le cas suivant:
                // TODO TF1: définir un filtre de prix
                // TODO TF1: aller dans un produit
                // TODO TF1: revenir
                // TODO TF1: les 2 sélecteurs du filtre de prix sont au minimum, mais avec les bon prix sélectionné
                // let localFilters;
                globalMin = Math.min(productsList.data.priceMin[taxDisplay], productsList.data.specialPriceMin[taxDisplay]);
                globalMax = Math.max(productsList.data.priceMax[taxDisplay], productsList.data.specialPriceMax[taxDisplay]);
                min = globalMin;
                max = globalMax;

                // Récupération des bornes min et max du slider de prix dans le local storage si elles existent
                if (typeof window !== 'undefined') {
                    let globalMinMaxFilter = window.localStorage.getItem('globalMinMaxFilter');
                    if (globalMinMaxFilter && JSON.parse(globalMinMaxFilter).category !== category.name) {
                        window.localStorage.removeItem('globalMinMaxFilter');
                        globalMinMaxFilter = null;
                    }
                    let localFilters = window.localStorage.getItem('filters');
                    const isFilterMinMax = localFilters ? localFilters.indexOf(`price.${taxDisplay}.normal`) > -1 : false;
                    localFilters = JSON.parse(localFilters);
                    search = localFilters && localFilters.filters && localFilters.filters.$text ? localFilters.filters.$text.$search : '';

                    if (!isFilterMinMax && !globalMinMaxFilter) {
                        window.localStorage.setItem('globalMinMaxFilter', JSON.stringify({ category: category.name, min, max }));
                    } else if (globalMinMaxFilter) {
                        globalMin = JSON.parse(globalMinMaxFilter).min;
                        globalMax = JSON.parse(globalMinMaxFilter).max;
                    }
                }


                specialMin = productsList.data.specialPriceMin[taxDisplay];
                specialMax = productsList.data.specialPriceMax[taxDisplay];

                // TODO TF1
                // if (typeof window !== 'undefined') {
                //     localFilters = JSON.parse(window.localStorage.getItem('filters'));
                //
                //     if (localFilters && localFilters.$and) {
                //         min = localFilters.$and[0].$or[0][`price.${taxDisplay}.normal`].$gte;
                //         max = localFilters.$and[0].$or[0][`price.${taxDisplay}.normal`].$lte;
                //         specialMin = localFilters.$and[0].$or[1][`price.${taxDisplay}.special`].$gte;
                //         specialMax = localFilters.$and[0].$or[1][`price.${taxDisplay}.special`].$lte;
                //     }
                // }

                filters = /* typeof window !== 'undefined' && localFilters && localFilters.category === category.name ? localFilters : */ { // TODO TF1
                    $and : [{
                        $or : [
                            {
                                [`price.${taxDisplay}.normal`] : {
                                    $gte : productsList.data.priceMin[taxDisplay] || 0,
                                    $lte : Math.ceil(productsList.data.priceMax[taxDisplay]) || 0
                                }
                            }, {
                                [`price.${taxDisplay}.special`] : {
                                    $gte : productsList.data.priceMin[taxDisplay] || 0,
                                    $lte : Math.ceil(productsList.data.priceMax[taxDisplay]) || 0
                                }
                            }
                        ]
                    }]
                };
            }

            const cmsDiscover = await axios.post(`${getAPIUrl(ctx)}v2/component/ns-cms/discover`, { lang });

            return {
                ...datasComponentsCategory,
                taxDisplay,
                query        : ctx.query,
                category,
                filtersData  : category.filters,
                productsList : productsList.data.datas,
                filters,
                search,
                count        : productsList.data.count,
                globalMin,
                globalMax,
                min,
                max,
                specialMin,
                specialMax,
                current      : typeof window !== 'undefined' && window.localStorage.getItem('page') && category.name === JSON.parse(window.localStorage.getItem('page')).location ? JSON.parse(window.localStorage.getItem('page')).page : page,
                baseUrl,
                categories,
                cmsDiscover  : cmsDiscover.data,
            };
        } catch (error) {
            console.error(error);
            return error;
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            ...props,
            sort          : { sortWeight: -1 },
            itemsPerPages : defaultItemPerPage,
            selectedSort  : JSON.stringify({ field: 'sortWeight', sortValue: '-1' }),
            gridDisplay   : false,
            tab           : '',
        };
        this.priceRange = [];
        this.form = {};
    }

    onLangChange = async (lang) => {
        // On reconstruit l'URL avec la langue sélectionnée
        const { categories } = this.state;
        const slugs = [];
        categories.forEach((c) => {
            slugs.push(c.slug[lang]);
        });
        window.location.pathname = `${await getLangPrefix(lang)}/c/${slugs.join('/')}`;
    }

    componentDidMount = () => {
        if (typeof window !== 'undefined' && !this.props.notFound) {
            if (window.localStorage.getItem('gridDisplay') === 'true' || window.localStorage.getItem('gridDisplay') === 'false') {
                this.setState({ gridDisplay: (window.localStorage.getItem('gridDisplay') === 'true') });
            }
            const { category } = this.state;
            const localFilters = window.localStorage.getItem('filters');
            if (localFilters && JSON.parse(localFilters).category !== category.name) {
                window.localStorage.removeItem('filters');
            }
            const obj = localFilters && JSON.parse(localFilters).category === category.name ? JSON.parse(window.localStorage.getItem('filters')) : { filters: this.props.filters };

            // Récupération des bornes min et max du slider de prix dans le local storage si elles existent
            let globalMin = this.props.min;
            let globalMax = this.props.max;
            let globalMinMaxFilter = window.localStorage.getItem('globalMinMaxFilter');
            if (globalMinMaxFilter && JSON.parse(globalMinMaxFilter).category !== category.name) {
                window.localStorage.removeItem('globalMinMaxFilter');
                globalMinMaxFilter = null;
            }
            const isFilterMinMax = localFilters ? localFilters.indexOf(`price.${this.props.taxDisplay}.normal`) > -1 : false;
            if (!isFilterMinMax && !globalMinMaxFilter) {
                window.localStorage.setItem('globalMinMaxFilter', JSON.stringify({ category: category.name, min: globalMin, max: globalMax }));
            } else if (globalMinMaxFilter) {
                globalMin = JSON.parse(globalMinMaxFilter).min;
                globalMax = JSON.parse(globalMinMaxFilter).max;
            }
            this.setState({
                filters      : obj.category === category.name && obj.filters && obj.filters.$and && obj.filters.$and.length > 0 ? obj.filters : this.props.filters,
                checkedArray : obj.category === category.name && obj.checkedArray ? obj.checkedArray : [],
                search       : obj.category === category.name && obj.filters && obj.filters.$text ? obj.filters.$text.$search : '',
                globalMin,
                globalMax
            });
        }
    }

    handleSearch = (search) => {
        this.setState({ search });
    };

    search = (e) => {
        e.preventDefault();
        const { category } = this.props;
        const { filters, search } = this.state;
        if (search !== '') {
            filters.$text = { $search: search };
        } else {
            delete filters.$text;
        }
        let local_filters = JSON.parse(window.localStorage.getItem('filters'));
        if (local_filters) {
            local_filters.filters = filters;
        } else {
            local_filters = { category: category.name, filters, checkedArray: [] };
        }
        window.localStorage.setItem('filters', JSON.stringify(local_filters));
        this.setState({ filters }, () => {
            this.onPageChange(1, this.state.itemsPerPages, undefined, filters, '.section--sidebar');
        });
    }

    changeTab(tabName) {
        const { tab } = this.state;
        if (tab === tabName) return this.setState({ tab: '' });
        this.setState({ tab: tabName });
    }

    render() {
        const {
            cmsDiscover, notFound, nsCms_extraText, nsCms_extraText2, nsCms_extraText3, oCmsHeader, oCmsFooter, sitename, t
        } = this.props;
        if (notFound) {
            return (
                <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                    <Error statusCode={404} message="Not found" oCmsHeader={oCmsHeader} oCmsFooter={oCmsFooter} />
                </NSContext.Provider>
            );
        }
        const {
            category, count, itemsPerPages, productsList, gridDisplay, filters, search
        } = this.state;
        if (typeof window !== 'undefined' && /Mobi/.test(window.navigator.userAgent) && !gridDisplay) {
            this.setState({ gridDisplay: true });
            window.localStorage.setItem('gridDisplay', true);
        }
        return (
            <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                <Layout header={oCmsHeader.content} footer={oCmsFooter.content}>
                    <Head>
                        <title>{sitename} | {category.name !== undefined && category.name !== '' ? category.name : ''}</title>
                        {
                            category.metaDescription ? <meta name="description" content={category.metaDescription} /> : null
                        }
                        {parseInt(this.state.current, 0) === 2 && <link rel="prev" href={`${this.state.baseUrl}/`} />}
                        {parseInt(this.state.current, 0) > 2 && <link rel="prev" href={`${this.state.baseUrl}/${this.state.current - 1}`} />}
                        {parseInt(this.state.current, 0) < Math.ceil(count / itemsPerPages) && <link rel="next" href={`${this.state.baseUrl}/${this.state.current + 1}`} />}
                        <meta property="og:type" content="website" />
                    </Head>

                    <div className="main">
                        <div className="intro intro--alt color-white text-center">
                            <div className="decoration-arrow color-white">
                                <div className="decoration__img decoration__img--2">
                                    <img src="/images/medias/4154x2698/5e53d6c8664f2a3aa0e47d98/robot@2x.jpg" alt="" width="2077" height="1349" />
                                </div>{/* <!-- /.decoration__img --> */}
                            </div>{/* <!-- /.decoration-arrow --> */}

                            <div className="intro__inner">
                                <div className="shell">
                                    <h1>{category.name}</h1>

                                    <div className="form form--search color-gray">
                                        <form onSubmit={this.search}>
                                            <div className="form__controls form__controls--search bg-white">
                                                <label htmlFor="field-search" className="hidden">Search</label>

                                                <input id="field-search" className="field" type="text" value={search} placeholder={t('category:search')} onChange={(e) => this.handleSearch(e.target.value)} />

                                                <button type="button" className="form__icon" onClick={this.search}>
                                                    <i className="ico-search" />{/* <!-- /.ico-search --> */}
                                                </button>{/* <!-- /.form__icon --> */}
                                            </div>{/* <!-- /.form__controls --> */}
                                        </form>
                                    </div>{/* <!-- /.form --> */}
                                </div>{/* <!-- /.shell --> */}
                            </div>{/* <!-- /.intro__inner --> */}
                        </div>{/* <!-- /.intro --> */}

                        {nsCms_extraText2.content && <div className="section-banner" dangerouslySetInnerHTML={{ __html: nsCms_extraText2.content || '' }} />}{/* <!-- /.section-banner --> */}

                        <div className="section section--sidebar form">
                            <div className="section__inner">
                                <div className="shell">
                                    <form action="?" method="post">
                                        <div className="section__cols">
                                            {(category.filters && (category.filters.attributes.length > 0 || category.filters.pictos.length > 0)) && <Filters
                                                category={category}
                                                color="#f00"
                                                globalMin={this.state.globalMin}
                                                min={this.state.min}
                                                location={category.name}
                                                globalMax={this.state.globalMax}
                                                max={this.state.max}
                                                itemspp={itemsPerPages}
                                                page={this.state.current}
                                                t={t}
                                                reload={this.onPageChange}
                                                key={category._id}
                                            />}

                                            <div className="section__main">
                                                <div className="article article--intro">
                                                    <h2>{category.name}</h2>

                                                    <h4 dangerouslySetInnerHTML={{ __html: nsCms_extraText.content || '' }} />
                                                </div>{/* <!-- /.article --> */}

                                                <div className="filters">
                                                    <div className="filters__inner">
                                                        <div className="filter color-gray">
                                                            <label htmlFor="select-filter-sort">{t('category:trierPar')}</label>

                                                            <div className="select">
                                                                <select id="select-filter-sort" value={this.state.selectedSort} onChange={(e) => this.handleSort(JSON.parse(e.target.value), e.target.value, filters)}>
                                                                    <option value={JSON.stringify({ field: 'sortWeight', sortValue: '-1' })}>{t('category:pertinence')}</option>
                                                                    <option value={JSON.stringify({ field: 'price.et.normal', sortValue: '1' })}>{t('category:prix')} -</option> {/* TODO: trier par prix normal & discount */}
                                                                    <option value={JSON.stringify({ field: 'price.et.normal', sortValue: '-1' })}>{t('category:prix')} +</option>
                                                                    <option value={JSON.stringify({ field: 'reviews.average', sortValue: '-1' })}>{t('category:grade')}</option>
                                                                </select>
                                                            </div>{/* <!-- /.select --> */}
                                                        </div>{/* <!-- /.filter --> */}

                                                        <h4>{count} {t('category:results')}</h4>
                                                    </div>{/* <!-- /.filters__inner --> */}
                                                </div>{/* <!-- /.filters --> */}

                                                <div className="cards cards--alt">
                                                    <div className="cards__inner">
                                                        {
                                                            productsList.map((product, index) => (
                                                                <ProductCard from="category" key={product._id} type="data" value={product} mode={category.code} gNext={{ Router }} />
                                                            ))
                                                        }
                                                    </div>{/* <!-- /.cards__inner --> */}
                                                </div>{/* <!-- /.cards --> */}

                                                <ReactPaginate
                                                    containerClassName="list-pagination"
                                                    activeClassName="active"
                                                    previousLabel="&lt;"
                                                    breakLabel="…"
                                                    breakClassName="more"
                                                    nextLabel="&gt;"
                                                    pageCount={Math.ceil(count / itemsPerPages)}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={(page) => this.onPageChange({ ...page }, itemsPerPages, undefined, filters, '.section--sidebar')}
                                                    forcePage={this.state.current - 1}
                                                />
                                            </div>{/* <!-- /.section__main --> */}
                                        </div>{/* <!-- /.section__cols --> */}
                                    </form>
                                </div>{/* <!-- /.shell --> */}
                            </div>{/* <!-- /.section__inner --> */}
                        </div>{/* <!-- /.section --> */}

                        <div className="section-banner" dangerouslySetInnerHTML={{ __html: nsCms_extraText3.content || '' }} />{/* <!-- /.section-banner --> */}

                        <div className="section section--alt" dangerouslySetInnerHTML={{ __html: cmsDiscover.content }} />
                    </div>{/* <!-- /.main --> */}

                </Layout>
            </NSContext.Provider>
        );
    }

    static defaultProps = {
        search   : '',
        category : {
            productsList : [],
            filters      : [],
        },
        oCmsHeader : {
            content : '',
        },
        productsList : [],
        min          : 0,
        max          : 0,
        count        : 0,
        oCmsFooter   : {
            content : '',
        }
    };
}

export default withI18next(['category', 'product-card'])(PageCategory);
